module.exports = __webpack_public_path__ + "assets/img/discernment_cid_describe.014ca48b.png";